import { TYPES } from "../actions";

const initialState = {
  devicePacks: [],
  totalCount: 0,
  currentDevicePack: null,
  loading: false
};

export const tkt1DevicePackReducer = (state = initialState, action) => {
  switch (action.type) {

    case TYPES.ACTION_GET_TKT1_DEVICE_PACKS_SUCCESS:
      return { 
        ...state, 
        devicePacks: action.payload.data.result, 
        totalCount: action.payload.data.totalCount > -1 ? action.payload.data.totalCount : state.totalCount,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_DEVICE_PACKS_FAIL:
      return { 
        ...state, 
        devicePacks: [],
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_DEVICE_PACK_BY_ID_SUCCESS:
      return { 
        ...state, 
        currentDevicePack: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_DEVICE_PACK_BY_ID_FAIL:
      return { 
        ...state, 
        currentDevicePack: null,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_DEVICE_PACK_BY_SN_SUCCESS:
      return { 
        ...state, 
        currentDevicePack: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_DEVICE_PACK_BY_SN_FAIL:
      return { 
        ...state, 
        currentDevicePack: null,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_DEVICE_PACK_BY_NETWORK_SN_SUCCESS:
      return { 
        ...state, 
        currentDevicePack: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_DEVICE_PACK_BY_NETWORK_SN_FAIL:
      return { 
        ...state, 
        currentDevicePack: null,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_DEVICE_PACK_BY_PC_SN_SUCCESS:
      return { 
        ...state, 
        currentDevicePack: action.payload.data,
        loading: false
      };

    case TYPES.ACTION_GET_TKT1_DEVICE_PACK_BY_PC_SN_FAIL:
      return { 
        ...state, 
        currentDevicePack: null,
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_DEVICE_PACK_SUCCESS:
      return { 
        ...state, 
        devicePacks: [action.payload.data, ...state.devicePacks],
        totalCount: state.totalCount + 1,
        loading: false
      };

    case TYPES.ACTION_CREATE_TKT1_DEVICE_PACK_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_DEVICE_PACK_SUCCESS:
      return { 
        ...state, 
        devicePacks: state.devicePacks.map(pack => 
          pack._id === action.payload.data._id ? action.payload.data : pack
        ),
        currentDevicePack: state.currentDevicePack && state.currentDevicePack._id === action.payload.data._id 
          ? action.payload.data 
          : state.currentDevicePack,
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_DEVICE_PACK_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_DEVICE_PACK_BY_SN_SUCCESS:
      return { 
        ...state, 
        devicePacks: state.devicePacks.map(pack => 
          pack.SN === action.payload.data.SN ? action.payload.data : pack
        ),
        currentDevicePack: state.currentDevicePack && state.currentDevicePack.SN === action.payload.data.SN 
          ? action.payload.data 
          : state.currentDevicePack,
        loading: false
      };

    case TYPES.ACTION_UPDATE_TKT1_DEVICE_PACK_BY_SN_FAIL:
      return { 
        ...state, 
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_DEVICE_PACK_SUCCESS:
      return { 
        ...state, 
        devicePacks: state.devicePacks.filter(pack => pack._id !== action.payload.id),
        totalCount: Math.max(0, state.totalCount - 1),
        currentDevicePack: state.currentDevicePack && state.currentDevicePack._id === action.payload.id 
          ? null 
          : state.currentDevicePack,
        loading: false
      };

    case TYPES.ACTION_DELETE_TKT1_DEVICE_PACK_FAIL:
      return { 
        ...state, 
        loading: false
      };
      
    default:
      return state;
  }
};
